import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import InputsChangeHandler from "./InputsChangeHandler";
import { PootsyTextInput } from './InputsFunctions'
import { PootsyButton } from './DesignFunctions'
import * as actions from "../actions/acAccountSecurity"
import ModalLayout from "./shared/ModalLayout"

class AccountSecurity extends Component {

	state = {
		showSuccessModal: false
	}

	render() {
		let { t } = this.context

		let { oldPassword, newPassword, newPasswordConfirmation } = this.props.data
		let { canSubmit, form_errors, result } = this.props.meta

		return (
			<InputsChangeHandler onChange={this.handleFormChanges}>
				<div className="AccountSecurity">
					{this.renderResult(result)}
					<PootsyTextInput
						name="oldPassword"
						label={t('old_password_input_label')}
						value={oldPassword}
						showError={form_errors['old_password']}
						type="password"
					/>
					<PootsyTextInput
						name="newPassword"
						label={t('new_password_input_label')}
						value={newPassword}
						showError={form_errors["new_password"]}
						type="password"
					/>
					<PootsyTextInput
						name="newPasswordConfirmation"
						label={t('new_password_confirmation_input_label')}
						value={newPasswordConfirmation}
						showError={form_errors["new_password_confirmation"]}
						type="password"
						onKeyPress={this.handleSubmit}
					/>
					<PootsyButton text={t('common_confirm')}
								  onClick={this.onUpdatePasswordButtonClick}
								  disabled={!canSubmit}
					/>
				</div>
			</InputsChangeHandler>
		)
	}

	handleFormChanges = changes => {
		this.props.dispatch(actions.processDataChange(changes))
	}

	onUpdatePasswordButtonClick = () => {
		this.props.dispatch(actions.updatePassword())
	}

	renderResult = () => {
		if (!this.props.meta.showModal) {
			return null
		}

		let { t } = this.context

		return (
			<ModalLayout
				buttons={[
					<PootsyButton text={t("ok")} onClick={this.closeSuccessModal} key={1}/>
				]}
			>
				<div>{this.props.meta.result.success ? t('update_password_success') : t('update_password_failure')}</div>
			</ModalLayout>
		)
	}

	closeSuccessModal = () => {
		this.props.dispatch(actions.toggleModal())
	}

	handleSubmit = e => {
		if(e.key === 'Enter'){
			this.props.dispatch(actions.updatePassword())
		}
	}
}

const mapStateToProps = state => ({
	data: state.dataReducer.accountSecurity,
	meta: state.metadataReducer.accountSecurity
})

AccountSecurity.contextTypes = { t: PropTypes.func }
export default connect(mapStateToProps)(AccountSecurity);



// WEBPACK FOOTER //
// ./src/components/AccountSecurity.js